import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import {
  setDevReporterId,
  getCurrentReporterId,
} from './app/utility/app-token';
import { environment } from './environments/environment';

// 開発用: コンソールから setDevReporterId, getCurrentReporterId を呼べるのは開発モードのみ
if (!environment.production) {
  (window as any).setDevReporterId = setDevReporterId;
  (window as any).getCurrentReporterId = getCurrentReporterId;
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
